import { z } from '../zod.js';

export const SUBMISSION_STATUSES = Object.freeze({
  succeeded: 'succeeded',
  failed: 'failed',
});

export const SubmissionStatusValidationEnum = z.enum(SUBMISSION_STATUSES);
